import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { createSlice } from '@reduxjs/toolkit'
import { getTimezoneOffset } from '@features/General/dayjs/hanlers'

dayjs.extend(utc)
dayjs.extend(timezone)
export interface IMeetingAgendaDataState {
    pagination: {
        itemsPerPage: number
        currentPage: number
        total: number
    }
    preLoading?: boolean
    searchValue: string | null
    filters?: any
    pureFilters?: any
    sort?: any
    projection?: any
    needPopulate: boolean
    populates?: any
}

const initialState: IMeetingAgendaDataState = {
    pagination: {
        itemsPerPage: 10,
        currentPage: 1,
        total: 0
    },
    preLoading: true,
    searchValue: null,
    filters: {
        status: ['Scheduled'],
        startTime: { $gte: dayjs().utc().set('hour', 0).set('minute', 0).set('second', 0).format() }
    },
    pureFilters: {
        status: ['Scheduled'],
        meetingDate: [dayjs(), null],
        timeShift: '',
        eventTimeShift: ''
    },
    sort: { startTime: 1, _id: -1 },
    projection: [],
    // projection: [
    //     '_id',
    //     'place',
    //     { path: 'hallId', select: 'name' },
    //     { path: 'tableId', select: 'name' },
    //     'startTime',
    //     'endTime',
    //     'meetingType',
    //     'status',
    //     { path: 'hostIds', select: '_id firstname lastname email mobile' },
    //     { path: 'guestIds', select: '_id firstname lastname email mobile' },
    //     { path: 'hostCompanyId', select: '_id name email country' },
    //     { path: 'guestCompanyId', select: '_id name email country' }
    // ],
    needPopulate: true,
    populates: []
}

const meetingAgendaSlice = createSlice({
    name: 'ui/meeting-agenda',
    initialState,
    reducers: {
        onChangePreLoading(state, action) {
            state.preLoading = action.payload
        },
        onChangePagination(state, action) {
            state.pagination = { ...state.pagination, ...action.payload }
        },
        onChangeItem(state, action) {
            state[action.payload.key] = action.payload.value
        },
        onChangeSearch(state, action) {
            state.searchValue = action.payload
        },
        onChangeTotal(state, action) {
            state.pagination = { ...state.pagination, total: action.payload }
        },
        onChangeFilters(state, action) {
            state.filters = action.payload
            // const objectkeys = Object.keys(action.payload)
            // state.filters = {}
            // for (const key of objectkeys) {
            //     state.filters[key] = action.payload[key]
            // }
        },
        onChangePureFilters(state, action) {
            state.pureFilters = {
                eventTimeShift: state.pureFilters.eventTimeShift,
                timeShift: state.pureFilters.eventTimeShift || getTimezoneOffset(dayjs.tz.guess()),
                ...action.payload
            }
        },
        addPureFilter(state, action) {
            const objectkeys = Object.keys(action.payload)
            for (const key of objectkeys) {
                state.pureFilters[key] = action.payload[key]
            }
        },
        onResetFilters(state) {
            state.filters = {}
            state.pureFilters = {
                eventTimeShift: state.pureFilters.eventTimeShift,
                timeShift: state.pureFilters.eventTimeShift || getTimezoneOffset(dayjs.tz.guess())
            }
        }
    }
})

export const meetingAgendaActions = meetingAgendaSlice.actions
export default meetingAgendaSlice.reducer
